const percentageRe = "^[0-9]{0,3}\\.?[0-9]{0,2}$";
export { percentageRe };
